type PortalProduct = 'hq' | 'fitness' | 'music';

const products: Array<{ id: PortalProduct; label: string; detail: string; href: string }> = [
  { id: 'hq', label: 'HQ', detail: 'Work', href: 'https://hq.caydenlasher.co/' },
  { id: 'fitness', label: 'Fitness', detail: 'Health', href: 'https://fitness.caydenlasher.co/' },
  { id: 'music', label: 'Music', detail: 'Library', href: 'https://music.caydenlasher.co/' },
];

export function PortalSwitcher({ active, compact = false, className = '' }: { active: PortalProduct; compact?: boolean; className?: string }) {
  return <nav className={`portal-switcher${compact ? ' compact' : ''}${className ? ` ${className}` : ''}`} aria-label="Cayden OS apps">
    {products.map((product) => <a
      key={product.id}
      className={product.id === active ? 'active' : ''}
      href={product.href}
      aria-current={product.id === active ? 'page' : undefined}
    >
      <span>{product.label}</span>
      {!compact && <small>{product.detail}</small>}
    </a>)}
  </nav>;
}
